import { render, staticRenderFns } from "./TicketTvas.vue?vue&type=template&id=22a0cc4c"
import script from "./TicketTvas.vue?vue&type=script&lang=ts"
export * from "./TicketTvas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a0cc4c')) {
      api.createRecord('22a0cc4c', component.options)
    } else {
      api.reload('22a0cc4c', component.options)
    }
    module.hot.accept("./TicketTvas.vue?vue&type=template&id=22a0cc4c", function () {
      api.rerender('22a0cc4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/TicketTvas.vue"
export default component.exports